import { render, staticRenderFns } from "./DeviceData_Default.vue?vue&type=template&id=2c9e953f&scoped=true&"
import script from "./DeviceData_Default.vue?vue&type=script&lang=js&"
export * from "./DeviceData_Default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e953f",
  null
  
)

export default component.exports